import { useGlobalErrorHandler, useMutation } from '@src/hooks'
import { useParams } from 'react-router-dom' 
import { ImportService } from '@src/domain/services'
import { Category } from '@src/domain/repositories/import.repo'
import { useDialog } from '@src/components/dialog'
import { useSpinner } from '@src/components/spinner'
import { ModalResolveType } from '@src/lib/modal-manager'
import { useEffect, useState } from 'react'

export function DataImportViewModel() {
  const params = useParams()
  const category = params.category as Category
  const [shippingNo, setShippingNo] = useState('')
  const { dialog } = useDialog()
  const { spinner } = useSpinner()
  const { globalErrorHandler } = useGlobalErrorHandler()

  const { mutate: uploadFile } = useMutation(ImportService.uploadFile)
  const { mutate: deleteCarInfoByShippingNo } = useMutation(ImportService.deleteCarInfoByShippingNo)
  
  useEffect(() => {
    return () => {
      setShippingNo('')
    }
  }, [category])

  const importFile = async (file: File) => {
    try {
      await spinner(uploadFile({ category, file }))
      await dialog.alert({
        title: '訊息',
        message: '上傳成功'
      })
    } catch (error) {
      globalErrorHandler(error)
    }
  }

  const handleCarInfoDelBtnOnClick = async (shippingNo: string) => {
    if (!shippingNo) return
    const result = await dialog.confirm({
      title: '刪除確認',
      message: `是否要刪除這船資料`
    })

    if (result.type !== ModalResolveType.OK) return

    try {
      await spinner(deleteCarInfoByShippingNo({ shippingNo }))
      setShippingNo('')
    } catch (error) {
      globalErrorHandler(error)
    }
  }

  return { category, importFile, shippingNo, setShippingNo, handleCarInfoDelBtnOnClick }
}

export type IDataImportViewModel = ReturnType<typeof DataImportViewModel>
